const fbConfig = {
  API_KEY: process.env.REACT_APP_API_KEY,
  AUTH_DOMAIN: process.env.REACT_APP_AUTH_DOMAIN,
  DATABASE_URL: process.env.REACT_APP_DATABASE_URL,
  PROJECT_ID: process.env.REACT_APP_PROJECT_ID,
  STORAGE_BUCKET: process.env.REACT_APP_STORAGE_BUCKET,
  MESSAGING_SENDER_ID: process.env.REACT_APP_MESSAGING_SENDER_ID,
  APP_ID: process.env.REACT_APP_APP_ID,
  FUNCTIONS_BASE_URL: process.env.REACT_APP_FUNCTIONS_BASE_URL,
};

const functionsKeys = {
  AUTH_CODE: process.env.REACT_APP_AUTH_CODE
};

const countryCodes = {
  CA: 'CA',
  US: 'US',
  BO: 'BO',
};

const TSEnvironment = {
  ENABLE_FUNCTIONS: false,
};

module.exports = {
  fbConfig,
  functionsKeys,
  countryCodes,
  TSEnvironment,
};
